// SQL datetime values lose their UTC kind when serialized without an offset.
// Use this only for API fields whose writers explicitly store UTC timestamps.
export const parseUtcDateTime = (value) => {
  const timestamp =
    typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value) &&
    !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)
      ? `${value}Z`
      : value;
  return new Date(timestamp);
};
